import * as types from "../constants/actionTypes";
import initialState from "./initialState";

export const selectedHotelIdReducer = (
  state = initialState.selectedHotelID,
  action
) => {
  switch (action.type) {
    case types.SELECTED_HOTEL_ID: {
      return action.payload || initialState.selectedHotelID;
    }
    case types.UPDATE_SELECTED_OPTION: {
      if (action.payload.optionType === "Hotel") {
        return action.payload.value;
      } else {
        return state;
      }
    }

    case types.SET_SEARCH_DATA:
      return (
        (action.payload && action.payload.SelectedHotelID) ||
        initialState.selectedHotelID
      );

    default:
      return state;
  }
};

export const selectedRegionIdReducer = (
  state = initialState.selectedRegionID,
  action
) => {
  switch (action.type) {
    case types.SELECTED_REGION_ID: {
      return action.payload || initialState.selectedRegionID;
    }
    case types.UPDATE_SELECTED_OPTION: {
      if (action.payload.optionType === "Region") {
        return action.payload.value;
      } else {
        return state;
      }
    }

    default:
      return state;
  }
};

export const selectedCityCodeReducer = (
  state = initialState.selectedCityCode,
  action
) => {
  switch (action.type) {
    case types.SELECTED_CITY_CODE: {
      return action.payload || initialState.selectedCityCode;
    }
    case types.UPDATE_SELECTED_OPTION: {
      if (action.payload.optionType === "City") {
        return action.payload.value;
      } else {
        return state;
      }
    }

    default:
      return state;
  }
};

export const selectedDealIdReducer = (
  state = initialState.selectedDealID,
  action
) => {
  switch (action.type) {
    case types.SELECTED_DEAL_ID: {
      return action.payload || initialState.selectedDealID;
    }
    case types.RESET_SELECTED_DEAL: {
      return state;
    }

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/hotelsReducer.js